<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Components</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
      <router-link :to="{name: 'client-components'}">
        <i class="fas fa-exchange-alt"></i> Switch to User View
      </router-link>
    </span>
    <b-tabs card no-fade @input="resetForm">
      <b-tab title="All" active>
        <all/>
      </b-tab>
      <b-tab title="Archived">
        <archived/>
      </b-tab>
      <b-tab title="<i class='fas fa-plus'></i> Add">
        <add ref="add"/>
      </b-tab>
    </b-tabs>
  </page>
</template>

<script>
import add from './add'
import all from './all'
import archived from './archived'
import page from '../../../templates/page'
import sidebar from '../../../sidebar'

export default {
  components: {
    add,
    all,
    archived,
    sidebar,
    page
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Modules',
        to: { name: 'admin-modules' }
      },
      {
        text: 'Components',
        active: true
      }]
    }
  },
  methods: {
    resetForm (e) {
      if (!this.$refs.add.saving) {
        this.$refs.add.resetForm()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/components/index.vue